module.exports = __webpack_public_path__ + "img/IMG_7988 edit.191c174e.webp";